import React from 'react'

const Bounce = () => {
    return (
        <div className="ball__container"> <div className='ball'></div> </div>
    )
}

export default Bounce